// ============================================================
// src/domain/cost.ts — COST ENGINE
// ============================================================

import { SpatialData, CostBreakdown } from './types';
import {
  MIN_RBG_2026,
  RYZYKO_BUFOR_PCT,
  MATERIAL_RATE_M2,
  GRUNT_PLN_M2,
  GLADZ_PLN_M2,
} from '../core/zasady/constants';
import { roundMoney } from './money';

export function calculateCosts(
  spatial: SpatialData,
  regionMultiplier: number = 1.0
): CostBreakdown {
  const area = spatial.flatSurfaceM2;
  
  // FALLBACK: Jeśli area = 0, użyj minimalnej wartości żeby wycena nie była zerem
  const effectiveArea = area > 0 ? area : 20; // minimalne 20m²
  
  // Robocizna — stawka MIN_RBG_2026 jako podłoga
  const baseLabor = effectiveArea * MIN_RBG_2026 * 0.45; // 0.45h/m² norma
  const labor = baseLabor * regionMultiplier;

  // Materiały — BOM bazowy (zastąpić API hurtowni gdy będzie)
  const materials =
    effectiveArea * (MATERIAL_RATE_M2 + GRUNT_PLN_M2 + GLADZ_PLN_M2 * 0.3)
    * regionMultiplier;

  const riskBuffer = (materials + labor) * RYZYKO_BUFOR_PCT;

  return {
    materials: roundMoney(materials),
    labor: roundMoney(labor),
    margin: 0, // uzupełnia margin.ts
    riskBuffer: roundMoney(riskBuffer),
    total: roundMoney(materials + labor + riskBuffer),
  };
}
